import { render, staticRenderFns } from "./ManagementStatement.vue?vue&type=template&id=5d06114a&v-if=isLoggedIn&"
import script from "./ManagementStatement.vue?vue&type=script&lang=js&"
export * from "./ManagementStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports